/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SelectRoleDto = {
    /**
     * The role to assign to the user
     */
    role: SelectRoleDto.role;
};
export namespace SelectRoleDto {
    /**
     * The role to assign to the user
     */
    export enum role {
        CLIENT = 'client',
        EXPERT = 'expert',
    }
}

